import { httpClient } from "@/services";

export default {
	state: {
		reportsOldList: null,
		reportsOldFilter: null,
		reportsSafetyList: null,
		reportsSafetyFilter: null,
		reportsBillingList: null,
		reportsBillingFilter: null,
		reportPending: false,
		reportsError: null,
		createReportsList: null
	},
	getters: {
		reportsOldList: s => s.reportsOldList,
		reportsOldFilter: s => s.reportsOldFilter,
		reportsSafetyList: s => s.reportsSafetyList,
		reportsSafetyFilter: s => s.reportsSafetyFilter,
		reportsBillingList: s => s.reportsBillingList,
		reportsBillingFilter: s => s.reportsBillingFilter,
		reportsError: s => s.reportsError,
		createReportsList: s => s.createReportsList,
		reportPending: s => s.reportPending
	},
	mutations: {
		updateReportsList(state, payload) {
			state.reportsOldList = payload.reports;
			state.reportsOldFilter = payload.filter;
		},
		updateReportsSafetyList(state, payload) {
			state.reportsSafetyList = payload.reports;
			state.reportsSafetyFilter = payload.filter;
		},
		updateReportsBillingList(state, payload) {
			state.reportsBillingList = payload.reports;
			state.reportsBillingFilter = payload.filter;
		},
		updateReportPending(state, payload) {
			state.reportPending = payload;
		},
		updateReportsError(state, payload) {
			state.reportsError = payload;
		},
		updateCreateReportsList(state, payload) {
			state.createReportsList = payload;
		}
	},
	actions: {
		async getReportsOldList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/reports');

				if (data && !data.status) {
					commit('updateReportsList', data);
					commit('updateReportsError', null);
					// dispatch("actionPreloader", false);
				} else {
					commit('updateReportsError', data.message);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getReportsFilter({ commit }, payload) {
			// dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/reports/list', payload);

				if (data && !data.status) {
					commit('updateReportsList', data);
					commit('updateReportsError', null);
					// dispatch("actionPreloader", false);
				} else {
					commit('updateReportsError', data.message);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getReportsSafetyList({ commit }) {
			try {
				const { data } = await httpClient.get('/reports/safety');

				if (data && !data.status) {
					commit('updateReportsSafetyList', data);
					commit('updateReportsError', null);
				} else {
					commit('updateReportsError', data.message);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getReportsSafetyFilter({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/reports/safety/list', payload);

				if (data && !data.status) {
					commit('updateReportsSafetyList', data);
					commit('updateReportsError', null);
					dispatch("actionPreloader", false);
				} else {
					commit('updateReportsError', data.message);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getReportsBillingList({ commit, dispatch }) {
			try {
				const { data } = await httpClient.get('/reports/billing');

				if (data && !data.status) {
					commit('updateReportsBillingList', data);
					commit('updateReportsError', null);
					dispatch("actionPreloader", false);
				} else {
					commit('updateReportsError', data.message);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getReportsBillingFilter({ commit }, payload) {
			// dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/reports/billing/list', payload);

				if (data && !data.status) {
					commit('updateReportsBillingList', data);
					commit('updateReportsError', null);
					// dispatch("actionPreloader", false);
				} else {
					commit('updateReportsError', data.message);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async sentCreateReports({ commit, dispatch }, values) {
			const customers = values;

			dispatch("actionPreloader", true);

			try {
				const { data } = await httpClient.post('/reports', { customers });

				if (data && data.status) {
					commit('updateCreateReportsList', null);
					dispatch("actionPreloader", false);
				}

				return data.status;
			} catch (e) {
				console.error(e);
			}
		},
		async sendReportToPost(context, { id, email }) {
			try {
				const { data } = await httpClient.post(`/reports/send/${ id }`, { email });

				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async sendSafetyReportToPost(context, { id, email }) {
			try {
				const { data } = await httpClient.post(`/reports/safety/send/${ id }`, { email });

				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async sendBillingReportToPost(context, { id, email }) {
			try {
				const { data } = await httpClient.post(`/reports/billing/send/${ id }`, { email });

				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onCreateReports({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			commit('updateReportPending', true);

			try {
				const { data } = await httpClient.post('/reports/create', values);

				if (data && data.status) {
					commit('updateCreateReportsList', data.customers);
					commit('updateReportsError', null);
					dispatch("actionPreloader", false);
				} else {
					commit('updateReportsError', data.status);
				}
			} catch (e) {
				console.error(e);
			}

			commit('updateReportPending', false);
		},
		async onSendReportFromInvoice(context, { invoice_id, email }) {
			try {
				return await httpClient.post(`/invoice/sendStatistic/${ invoice_id }`, { email });
			} catch (e) {
				console.error(e);
			}
		}
	}
};
